import { render, staticRenderFns } from "./order_pay_dialog.vue?vue&type=template&id=6a528c21&scoped=true"
import script from "./order_pay_dialog.vue?vue&type=script&lang=js"
export * from "./order_pay_dialog.vue?vue&type=script&lang=js"
import style0 from "./order_pay_dialog.vue?vue&type=style&index=0&id=6a528c21&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a528c21",
  null
  
)

export default component.exports